import { NgModule } from '@angular/core';
import { NGRX_BUCKETS } from '@curbnturf/entities';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import * as locationEffects from './+state/location.effects';
import { initialState as locationInitialState, locationReducer } from './+state/location.reducer';
import { GeolocationCapacitorService } from './geolocation-capacitor.service';

@NgModule({
  providers: [
    GeolocationCapacitorService,
    provideState(NGRX_BUCKETS.location, locationReducer, {
      initialState: locationInitialState,
    }),
    provideEffects(locationEffects),
  ],
})
export class LocationModule {}
